import { REQUEST_INVOICE_FILTER } from "../Invoices/constants";

export const WORKFLOWS_DOMAIN = 'app/modules/Contents/WORKFLOWS_DOMAIN';
export const REQUEST_WORKFLOW = 'app/modules/Contents/REQUEST_WORKFLOW';
export const REQUEST_WORKFLOWS = 'app/modules/Contents/REQUEST_WORKFLOWS';
export const REQUEST_WORKFLOWS_FILTER = 'app/modules/Contents/REQUEST_WORKFLOWS_FILTER';
export const FILTER_DEFAULT_LIMIT = 50;
export const REQUEST_CREATE_WORKFLOW = 'app/modules/Contents/REQUEST_CREATE_WORKFLOW';
export const REQUEST_UPDATE_WORKFLOW = 'app/modules/Contents/REQUEST_UPDATE_WORKFLOW';

export const REQUEST_DELETE_WORKFLOW = 'app/modules/Contents/REQUEST_DELETE_WORKFLOW';
export const REQUEST_ADD_WORKFLOW_PRODUCT = 'app/modules/Contents/REQUEST_ADD_WORKFLOW_PRODUCT';
export const REQUEST_FETCH_WORKFLOW_PRODUCT = 'app/modules/Contents/REQUEST_FETCH_WORKFLOW_PRODUCT';
export const REQUEST_UPDATE_WORKFLOW_PRODUCT = 'app/modules/Contents/REQUEST_UPDATE_WORKFLOW_PRODUCT';
export const REQUEST_DELETE_WORKFLOW_PRODUCT = 'app/modules/Contents/REQUEST_DELETE_WORKFLOW_PRODUCT';
export const REQUEST_ADD_WORKFLOW_TASK = 'app/modules/Contents/REQUEST_ADD_WORKFLOW_TASK';
export const REQUEST_UPDATE_WORKFLOW_TASK = 'app/modules/Contents/REQUEST_UPDATE_WORKFLOW_TASK';
export const REQUEST_DELETE_WORKFLOW_TASK = 'app/modules/Contents/REQUEST_DELETE_WORKFLOW_TASK';

export const REQUEST_COMPANY_WORKFLOW = 'app/modules/Contents/REQUEST_COMPANY_WORKFLOW';
export const REQUEST_CREATE_COMPANY_WORKFLOW_TASK = 'app/modules/Contents/REQUEST_CREATE_COMPANY_WORKFLOW_TASK';
export const REQUEST_UPDATE_COMPANY_WORKFLOW_TASK = 'app/modules/Contents/REQUEST_UPDATE_COMPANY_WORKFLOW_TASK';

export const WORKFLOW_STATUSES = {
  OPEN: 0,
  FINAL: 1,
}
